export class CurrentInspectionTemplateError extends Error {
  constructor(message: string = 'Failed to fetch current inspection template') {
    super(message);
    this.name = 'CurrentInspectionTemplateError';
  }
}
